import { Fragment } from 'react';
import { AppBar, AppBarProps, Layout, LayoutProps, Logout, UserMenu } from 'react-admin';
import ThemeMenu from './ThemeMenu';
import ThemeModeProvider from './ThemeModeProvider';

const AppUserMenu = () => (
  <UserMenu>
    <ThemeMenu />
    <Logout />
  </UserMenu>
);

// react-admin hides its bar while the page scrolls down; on long lists that hid the page title and
// menu button. A plain fragment in place of that container keeps the bar on screen.
export const AlwaysOnAppBar = (props: AppBarProps) => <AppBar {...props} container={Fragment} userMenu={<AppUserMenu />} />;

const AppLayout = (props: LayoutProps) => (
  <ThemeModeProvider>
    <Layout {...props} appBar={AlwaysOnAppBar} />
  </ThemeModeProvider>
);

export default AppLayout;
